import RadioStack, {
  ExtendedRadioButtonProps,
} from '@components/ui/radio-stack';
import { CampaignOfferType, ProductScope } from '@givz/core-client';
import { FunctionComponent } from 'react';

const percentageAmountOptions: ExtendedRadioButtonProps[] = [
  {
    id: ProductScope.PercentageOfSubtotal,
    label: 'Calculate offer amount based on entire subtotal',
    name: ProductScope.PercentageOfSubtotal,
  },
  {
    id: ProductScope.PercentageOfProductTotal,
    label: 'Calculate offer amount based on total of specific products',
    name: ProductScope.PercentageOfProductTotal,
  },
];

const fixedAmountOptions: ExtendedRadioButtonProps[] = [
  {
    id: ProductScope.FixedAmountPerOrder,
    label: 'Apply fixed amount once per order',
    name: ProductScope.FixedAmountPerOrder,
  },
  {
    id: ProductScope.FixedAmountPerQuantity,
    label:
      'Apply fixed amount once per quantity ordered (of specific products)',
    name: ProductScope.FixedAmountPerQuantity,
  },
];

const ProductScopeStack: FunctionComponent<{
  offerType: CampaignOfferType;
  initialState?: ProductScope;
  onChange: (productScopeSelected: string) => void;
}> = ({ initialState = '', offerType, onChange }) => {
  const buttons =
    offerType === CampaignOfferType.Amount
      ? fixedAmountOptions
      : percentageAmountOptions;
  return (
    <RadioStack
      buttons={buttons}
      initialState={initialState}
      onToggle={(_, productScopeSelected) => onChange(productScopeSelected)}
    />
  );
};

export default ProductScopeStack;
